// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header_headerWrapper__FnMzm","infoWrap":"header_infoWrap__xPVh6","description":"header_description__qTero"};